__turbopack_context__.v({
  "iframeWrapper": "ReportEventIframeModal-module-scss-module__InNZLG__iframeWrapper",
  "modalContainer": "ReportEventIframeModal-module-scss-module__InNZLG__modalContainer",
  "reportEventIframe": "ReportEventIframeModal-module-scss-module__InNZLG__reportEventIframe",
});
